// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-61473641]{display:none}.grid-list__toggle[data-v-61473641]{margin:50px 0;display:flex;align-items:center;justify-content:right}.grid-list__toggle .toggle-icon[data-v-61473641]{color:var(--c-accent-4)}.grid-list__toggle .toggle-icon[data-v-61473641]:first-child{margin-right:14px}.grid-list__toggle .toggle-icon--active[data-v-61473641]{color:var(--c-black)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
